<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="查询日期">
              <!-- <j-date placeholder="请选择" v-model="queryParam.queryDate"/> -->
              <a-range-picker
                  style="width: 200px"
                  v-model="queryParam.queryDateRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <span style="margin-right: 60px;">币别：{{fcurrencyName}}</span>
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="departSlot" slot-scope="depart">
          <span v-if="depart.level===1">{{depart.text}}</span>
          <span v-else style="margin-left:45px;">{{depart.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'

  export default {
    name: 'BizOperationDayReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDate
    },
    data () {
      return {
        description: '运营日报表',
        disableMixinCreated: true,
        fcurrencyName:'人民币',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'部门',
            className: 'column-text',
            dataIndex: 'departName',
            scopedSlots: {customRender: 'departSlot'}
          },
        ],
        url: {
          list: "/bms/operateReport/getOperateReport",
          //exportXlsUrl: "/bms/bizFinancialBalance/exportXls",
          //importExcelUrl: "bms/bizFinancialBalance/importExcel",
        },
      }
    },
    created() {
      // 初始化表头
      this.getBusinessProject()
    },
    methods: {
      getBusinessProject(){
        // let url = "/bms/bizBusinessinfoBusinessType/list";
        // getAction(url).then(res=>{
        //   if(res.success){
        //     let businessTypes = res.result.records;
        //     this.initTableHeader(businessTypes)
        //   }
        // })
        
        let businessTypes = [
          {businessTypeNumber_dictText:'运维', businessTypeShort:'YW'},
          {businessTypeNumber_dictText:'直拓', businessTypeShort:'ZT'},
          {businessTypeNumber_dictText:'合作', businessTypeShort:'HZ'},
          {businessTypeNumber_dictText:'其他', businessTypeShort:'QT'}];
        this.initTableHeader(businessTypes)
      },
      initTableHeader(businessType){
        if(businessType){
          // 加载表头数据
          for(let i=0; i<businessType.length; i++){
            let typeColumn = {
                title: businessType[i].businessTypeNumber_dictText + '业务',
                children:[
                  {
                    title:'去税保费',
                    className: 'column-money',
                    dataIndex: businessType[i].businessTypeShort + 'JBF'
                  },
                  {
                    title:'去税佣金',
                    className: 'column-money',
                    dataIndex: businessType[i].businessTypeShort + 'JYJ'
                  },
                  {
                    title:'到账去税佣金',
                    className: 'column-money',
                    dataIndex: businessType[i].businessTypeShort + 'DZJYJ'
                  },
                ]
              }
            this.columns.push(typeColumn)
          }
          let typeColumn = {
            title: '总计',
            children:[
            {
              title:'去税保费',
              className: 'column-money',
              dataIndex: 'ZONJIJBF',
              customRender: function(text) {
                return !text ? '': text.toLocaleString();
              }
            },
            {
              title:'去税佣金',
              className: 'column-money',
              dataIndex: 'ZONJIJYJ',
              customRender: function(text) {
                return !text ? '': text.toLocaleString();
              }
            },
            {
              title:'到账去税佣金',
              className: 'column-money',
              dataIndex: 'ZONJIDZJYJ',
              customRender: function(text) {
                return !text ? '': text.toLocaleString();
              }
            }
          ]}
          this.columns.push(typeColumn)
          return true;
        } else {
          this.$message.warning("没有获取到业务类型字典数据，请重新登录！")
          return false
        }
      },

      onDateChange: function (value, dateString) {
        if(dateString.length >0 && dateString[0].length>0) {
          this.queryParam.queryDateRange = dateString;
        } else {
          this.queryParam.queryDateRange = null
        }
      },

      loadData() {
        if (!this.queryParam.queryDateRange) {
          this.$message.error("请选择查询日期!")
          return
        }
        let param = {}
        param.startTime = this.queryParam.queryDateRange[0] + ' 00:00:00'
        param.endTime = this.queryParam.queryDateRange[1] + ' 23:59:59'

        this.loading = true;
        getAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        // 顺序是确定的, level是报表中的级次，第一个子公司也是一级
        let departAndProject = [
          {text:'翔胜巴',level:1},
          {text:'其中：孙总直拓',level:1},
          {text:'鲁商集团',level:2},{text:'青岛机场',level:2},{text:'烟台机场',level:2},
          {text:'安能巴',level:1},
          {text:'其中：山东能源',level:1},
          {text:'久泰能源',level:2},{text:'山钢集团',level:2},{text:'其他',level:2},
          {text:'汇金巴',level:1},
          {text:'其中：政府采购',level:1},
          {text:'泰安校责险',level:2},{text:'商河营业部',level:1},{text:'邹平营业部',level:2},{text:'淄博分公司',level:2},
          {text:'博兴营业部',level:2},{text:'烟台分公司',level:2}, {text:'枣庄分公司',level:2},{text:'滨城营业部',level:2},
          {text:'滨北营业部',level:2},{text:'内蒙古分公司',level:2},{text:'乐陵分公司',level:2},{text:'临沂分公司',level:2},
          {text:'青岛分公司',level:2},{text:'德州分公司',level:2},{text:'保安行业',level:2},{text:'其他(汇金)',level:2},
          {text:'创业赋能与运营管理部',level:1},
          {text:'企划督导与人才优化部',level:1},
          {text:'经营核算与财务投资部',level:1},
          {text:'综合事务部',level:1},
          {text:'居安思危',level:1},
          {text:'合计',level:1}];

        let resData = [];
        let index = 1;
        for(let i=0; i<departAndProject.length; i++){ //按数组的顺序添加
          if(resultData[departAndProject[i].text]){
            let data = this.getDepartmentOrProjectData(departAndProject[i], resultData, index);
            resData.push(data);
            index++;
          }
        }
        return resData;
      },

      getDepartmentOrProjectData(departOrProject, resultData, index){
        let data = resultData[departOrProject.text];
        let
          YWJBF = 0.0, YWJYJ = 0.0, YWDZJYJ=0.0,
          ZTJBF = 0.0, ZTJYJ = 0.0, ZTDZJYJ=0.0,
          HZJBF = 0.0, HZJYJ = 0.0, HZDZJYJ=0.0,QTJBF = 0.0, QTJYJ = 0.0, QTDZJYJ=0.0,
          ZONJIJBF = 0.0, ZONJIJYJ = 0.0, ZONJIDZJYJ=0.0;

        if(data['YW']){ //运维
          YWJBF = data['YW']['cleanPremium']
          YWJYJ = data['YW']['cleanBrokerage']
          YWDZJYJ = data['YW']['payCleanBrokerage']
        }
        if(data['ZT']){ //直拓
          ZTJBF = data['ZT']['cleanPremium']
          ZTJYJ = data['ZT']['cleanBrokerage']
          ZTDZJYJ = data['ZT']['payCleanBrokerage']
        }
        if(data['HZ']){ //合作
          HZJBF = data['HZ']['cleanPremium']
          HZJYJ = data['HZ']['cleanBrokerage']
          HZDZJYJ = data['HZ']['payCleanBrokerage']
        }
        if(data['QT']){// 其他
          QTJBF = data['QT']['cleanPremium']
          QTJYJ = data['QT']['cleanBrokerage']
          QTDZJYJ = data['QT']['payCleanBrokerage']
        }
        if(data['ZONJI']){ // 行总计
          ZONJIJBF = data['ZONJI']['cleanPremium']
          ZONJIJYJ = data['ZONJI']['cleanBrokerage']
          ZONJIDZJYJ = data['ZONJI']['payCleanBrokerage']
        }

        return {id: index, departName : departOrProject,
          YWJBF:YWJBF, YWJYJ:YWJYJ, YWDZJYJ:YWDZJYJ,
          ZTJBF:ZTJBF, ZTJYJ:ZTJYJ, ZTDZJYJ:ZTDZJYJ,
          HZJBF:HZJBF, HZJYJ:HZJYJ , HZDZJYJ:HZDZJYJ,QTJBF:QTJBF, QTJYJ:QTJYJ, QTDZJYJ:QTDZJYJ,
          ZONJIJBF:ZONJIJBF, ZONJIJYJ:ZONJIJYJ, ZONJIDZJYJ:ZONJIDZJYJ}
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
